import React, { useState, useEffect } from 'react';
import firebase from 'firebase';
import Avatar from '@material-ui/core/Avatar';
// import { useSelector, useDispatch } from 'react-redux';

import './Post.css';
import { db, storage } from './firebase';
import LikeButton from './LikeButton';
import DropdownMenu from './components/Dropdown/DropdownMenu';

function Post({
  postId,
  count,
  user,
  username,
  caption,
  imageUrl,
  email,
  imageName,
}) {
  const [comments, setComments] = useState([]);
  const [comment, setComment] = useState('');
  const [image, setImage] = useState('');
  const [flag, setFlag] = useState(false);

  if (image == '') {
    if (email)
      storage
        .ref(`avatars/${email}-avatar.png`)
        .getDownloadURL()
        .then((url) => {
          setImage(url);
        });
  }
  useEffect(() => {
    // console.log('------email:', email)
    let unsubscribe;
    if (imageName != undefined) {
      // console.log(imageName.split('.')[1]);
      if (
        imageName.split('.')[1] === 'mp4' ||
        imageName.split('.')[1] === '3g2' ||
        imageName.split('.')[1] === 'webm'
      ) {
        setFlag(true);
      }
    }

    if (postId) {
      unsubscribe = db
        .collection('posts')
        .doc(postId)
        .collection('comments')
        .orderBy('timestamp', 'desc')
        .onSnapshot((snapshot) => {
          setComments(snapshot.docs.map((doc) => doc.data()));
        });
    }

    return () => {
      unsubscribe();
    };
  }, [postId]);

  const postComment = (event) => {
    event.preventDefault();

    db.collection('posts').doc(postId).collection('comments').add({
      text: comment,
      username: user.displayName,
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
    });
    setComment('');
  };

  return (
    <div className='post'>
      <div className='post_header'>
        <div className='post_header' style={{ width: '90%' }}>
          <Avatar className='post_avatar' alt='' src={image} />
          <h3>{username}</h3>
        </div>
        <DropdownMenu postId={postId} email={email} />
      </div>

      {flag ? (
        <video className='video' controls>
          <source
            className='post_image'
            src={imageUrl}
            alt=''
            type='video/mp4'
          />
        </video>
      ) : (
        <img
          style={{ width: '100%' }}
          className='post image'
          src={imageUrl}
          alt=''
        />
      )}

      <h4 className='post_text' style={{ display: 'flex' }}>
        <strong>{username} </strong>
        {caption}
        <LikeButton docId={postId} count={count} />
      </h4>

      <div style={{ maxHeight: 200, overflow: 'auto' }}>
        <div className='post_comments'>
          {comments.map((comment) => (
            <p>
              <strong style={{ margin: 5 }}>{comment.username}</strong>
              {comment.text}
            </p>
          ))}
        </div>

        {user && (
          <form className='post_commentBox'>
            <input
              className='post_input'
              type='text'
              placeholder='Add a comment...'
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
            <button
              className='post_button'
              disabled={!comment}
              type='submit'
              onClick={postComment}>
              Post
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export default Post;
